const DATE_FMT = new Intl.DateTimeFormat('es-AR', {
  day: 'numeric',
  month: 'short',
  year: 'numeric',
});

const MONTH_YEAR_FMT = new Intl.DateTimeFormat('es-AR', {
  month: 'long',
  year: 'numeric',
});

const WEEKDAY_FMT = new Intl.DateTimeFormat('es-AR', { weekday: 'short' });

export function formatIsoDate(iso: string): string {
  return DATE_FMT.format(new Date(`${iso}T12:00:00`));
}

export function formatMonthYear(iso: string): string {
  return MONTH_YEAR_FMT.format(new Date(`${iso}T12:00:00`));
}

export function formatWeekday(iso: string): string {
  return WEEKDAY_FMT.format(new Date(`${iso}T12:00:00`));
}

export function formatDayNumber(iso: string): string {
  return String(new Date(`${iso}T12:00:00`).getDate());
}
